import React from "react";
import { PanelBarGLPure, GridSelectionHLPure } from "../../pures";
import { Grid} from '@material-ui/core'

const ValidateFreelanceDocumentsView = (props) => {

    let {
        documents,
        t,
        handleWatchDoc,
        handleWathcVars
    } = props

    const headerColumnOne = (props) => {
        return <span className="validateFreelanceView-header-cell-one">{props.title}</span>;
    };
    
    const headerColumnTwo = (props) => {
        return <span className="validateFreelanceView-header-cell-two">{props.title}</span>;
    };

    const cellColumnOne = (props) => {
        return (
            <td className={`validateFreelanceView-cell-one ${props.dataItem.selected ? "validateFreelanceView-cell-selected" : ""}`}>
                <span className="gridHLPure-userName">
                    {props.dataItem.name}
                </span>
            </td>
        );
    };

    const cellColumnTwo = (props) => {
        return(
            <td className={`validateFreelanceView-cell-two ${props.dataItem.selected ? "validateFreelanceView-cell-selected" : ""}`}>
                <div className="validateFreelanceView-btns-docs">
                    <div className={"cellActions-containerBtnsDetails"}>
                        <button
                            className="cellActions-btn"
                            onClick={() => handleWatchDoc(props.dataItem)}
                        >
                            <p className="cellActions-textBotton">{t("documentPanelBarExpediente-watch-doc")}</p>
                        </button>
                    </div>
                    {
                        props.dataItem.valuesOCR && props.dataItem.valuesOCR.length > 0 && (
                            <div className={"cellActions-containerBtnsDetails"}>
                                <button
                                    className="cellActions-btn"
                                    onClick={() => handleWathcVars(props.dataItem)}
                                >
                                    <p className="cellActions-textBotton">{'Ver variables'}</p>
                                </button>
                            </div>
                        )
                    }
                </div>
            </td>
        )
    }
    
    let heightGrid = '320px'
    if(documents.length === 1 || documents.length === 0){
        heightGrid = '110px'
    }else if(documents.length === 2){
        heightGrid = '180px'
    }else if(documents.length === 3){
        heightGrid = '260px'
    }else{
        heightGrid = '320px'
    }

    return (
        <div>
            <PanelBarGLPure
                expandedPanel={true}
                titlePanel={t("validateFreelanceView.panel.documents")}
                className='validateFreelanceDocumentsView'
            >
                <Grid item className="validateFreelanceView-grid-documents">
                    <GridSelectionHLPure
                        styleGeneral={true}
                        styleGeneralClass={"validateFreelanceView-general-grid-documents"}
                        pageable={false}
                        skip={0}
                        take={documents.length}
                        dataGrid={documents}
                        filter={false}
                        columnTwo={true}
                        titleRow1={t("validateFreelanceView.grid.documents.title.one")}
                        titleRow2={t("validateFreelanceView.grid.documents.title.two")}
                        headerColumnOne={headerColumnOne}
                        headerColumnTwo={headerColumnTwo}
                        cellColumnOne={cellColumnOne}
                        cellColumnTwo={cellColumnTwo}
                        styleGrid={{ height: heightGrid }}
                    />
                </Grid>
            </PanelBarGLPure>
        </div>
    )
}

export { ValidateFreelanceDocumentsView as default }